const TWO = (n: number) => String(n).padStart(2, "0");

function parse(value: string | null | undefined): Date | null {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** `dd/mm/aa hh:mm` em pt-BR; `"—"` quando vazio ou inválido. */
export function formatDateTime(value: string | null | undefined): string {
  const date = parse(value);
  if (!date) return "—";
  return `${formatDate(value)} ${formatTime(value)}`;
}

/** `dd/mm/aa`; `"—"` quando vazio ou inválido. */
export function formatDate(value: string | null | undefined): string {
  const date = parse(value);
  if (!date) return "—";
  return `${TWO(date.getDate())}/${TWO(date.getMonth() + 1)}/${TWO(date.getFullYear() % 100)}`;
}

/** `hh:mm` (24 h); `"—"` quando vazio ou inválido. */
export function formatTime(value: string | null | undefined): string {
  const date = parse(value);
  if (!date) return "—";
  return `${TWO(date.getHours())}:${TWO(date.getMinutes())}`;
}

/** `"1 h 05 min"`, `"12 min"`, `"2 h"`; `"—"` quando nulo/inválido. */
export function formatDuration(minutes: number | null | undefined): string {
  if (minutes === null || minutes === undefined || !Number.isFinite(minutes) || minutes < 0) return "—";
  const total = Math.round(minutes);
  const hours = Math.floor(total / 60);
  const rest = total % 60;
  if (hours === 0) return `${rest} min`;
  if (rest === 0) return `${hours} h`;
  return `${hours} h ${TWO(rest)} min`;
}

/** Iniciais (até 2 letras) do primeiro e do último nome. */
export function initials(name: string): string {
  const parts = name
    .trim()
    .split(/\s+/)
    .filter((part) => part.length > 0);
  if (parts.length === 0) return "?";
  const first = parts[0]?.charAt(0) ?? "";
  const last = parts.length > 1 ? (parts[parts.length - 1]?.charAt(0) ?? "") : "";
  return `${first}${last}`.toUpperCase() || "?";
}
